module.exports = __webpack_public_path__ + "static/files@2x-f56b0fd49169ebf00b44a4dd1f30180d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/apple-watch-prototyping/files@2x.jpg
// module id = 325
// module chunks = 3528254163161 126761542922144 223471745239978